document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-lg-bespoke]").forEach((bespoke) => {
    document.body.classList.add("lg-bespoke-active");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const revealTargets = Array.from(bespoke.querySelectorAll("[data-lg-bespoke-reveal]"));

    if (reducedMotion || !("IntersectionObserver" in window)) {
      revealTargets.forEach((target) => target.classList.add("is-visible"));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.classList.add("is-visible");
          });
        },
        { rootMargin: "0px 0px -12%", threshold: 0.12 },
      );
      revealTargets.forEach((target) => revealObserver.observe(target));
    }

    const fireScene = bespoke.querySelector(".lg-bespoke-fire");
    if (
      fireScene
      && bespoke.dataset.fireMotion !== "false"
      && !reducedMotion
      && "IntersectionObserver" in window
    ) {
      const fireVideo = fireScene.querySelector("[data-lg-fire-video]");
      let fireVideoPrepared = false;
      let fireInView = false;

      const prepareFireVideo = () => {
        if (!fireVideo || fireVideoPrepared) return;
        fireVideo.querySelectorAll("source[data-src]").forEach((source) => {
          source.src = source.dataset.src;
          source.removeAttribute("data-src");
        });
        fireVideoPrepared = true;
        fireVideo.load();
      };

      fireVideo?.addEventListener("playing", () => fireScene.classList.add("has-live-fire"), { once: true });

      const syncFireMotion = () => {
        const isActive = fireInView && document.visibilityState === "visible";
        fireScene.classList.toggle("is-fire-active", isActive);
        if (isActive) {
          prepareFireVideo();
          fireVideo?.play().catch(() => {});
        } else {
          fireVideo?.pause();
        }
      };
      const fireObserver = new IntersectionObserver(
        (entries) => {
          fireInView = entries.some((entry) => entry.isIntersecting);
          syncFireMotion();
        },
        { rootMargin: "0px", threshold: 0.18 },
      );
      fireObserver.observe(fireScene);
      document.addEventListener("visibilitychange", syncFireMotion, { passive: true });
    }

    bespoke.querySelectorAll("[data-lg-bespoke-scroll]").forEach((link) => {
      link.addEventListener("click", (event) => {
        const target = document.querySelector(link.getAttribute("href"));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion ? "auto" : "smooth", block: "start" });
      });
    });

    const wechatButton = bespoke.querySelector("[data-lg-wechat-copy]");
    const wechatLabel = bespoke.querySelector("[data-lg-wechat-copy-label]");
    const wechatStatus = bespoke.querySelector("[data-lg-wechat-status]");
    const wechatId = bespoke.dataset.wechatId || "";

    const fallbackCopy = (value) => {
      const field = document.createElement("textarea");
      field.value = value;
      field.setAttribute("readonly", "");
      field.style.position = "fixed";
      field.style.opacity = "0";
      document.body.appendChild(field);
      field.select();
      const copied = document.execCommand("copy");
      field.remove();
      if (!copied) throw new Error("Copy command was not accepted");
    };

    wechatButton?.addEventListener("click", async () => {
      const copiedLabel = wechatButton.dataset.copiedLabel || "Copied";
      const copyLabel = wechatButton.dataset.copyLabel || "Copy";

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(wechatId);
        } else {
          fallbackCopy(wechatId);
        }
        if (wechatLabel) wechatLabel.textContent = copiedLabel;
        if (wechatStatus) wechatStatus.textContent = copiedLabel;
        wechatButton.classList.add("is-copied");
        window.setTimeout(() => {
          if (wechatLabel) wechatLabel.textContent = copyLabel;
          if (wechatStatus) wechatStatus.textContent = "";
          wechatButton.classList.remove("is-copied");
        }, 2600);
      } catch (error) {
        if (wechatStatus) wechatStatus.textContent = wechatId;
      }
    });

    const productReferenceWrap = bespoke.querySelector("[data-lg-product-reference]");
    const productReferenceInput = bespoke.querySelector("[data-lg-product-reference-input]");
    const query = new URLSearchParams(window.location.search);
    const productTitle = query.get("product_title") || "";
    const productHandle = query.get("product_handle") || "";
    const variantTitle = query.get("variant_title") || "";
    const variantId = query.get("variant_id") || "";
    const referenceParts = [productTitle, variantTitle, productHandle, variantId].filter(Boolean);
    if (productReferenceWrap && productReferenceInput && referenceParts.length) {
      productReferenceInput.value = referenceParts.join(" · ");
      productReferenceWrap.hidden = false;
    }

    const successMessage = bespoke.querySelector(".lg-bespoke-form__success");
    if (successMessage) successMessage.focus();
  });
});
